// Full catalogue of AI-filter prompt suggestions, grouped by theme (see ZQAAP-706 Figma).
// The i18n value for each key is the prompt sent to the backend when the suggestion is clicked.
// Role-weighting (favouring groups relevant to the user's role) is a planned follow-up;
// for now suggestions are picked uniformly at random.
const KEY_PREFIX = 'conversations.filters.ai_search.suggestion_'

export const SUGGESTION_KEYS: string[] = [
  // Sentiment / quality
  'negative_sentiment_last_week',
  'low_scoring_this_month',
  'frustrated_customers_last_30_days',
  'positive_sentiment_high_csat',
  'low_readability_last_2_weeks',
  'empathy_flagged',
  // Agent performance
  'escalated_assigned_to_team',
  'low_agent_reply_count',
  'ai_agent_churn_risk',
  'high_customer_reply_count',
  'low_scoring_by_assignee',
  'long_average_response_times',
  // Risk / escalation
  'churn_risk_last_2_weeks',
  'escalations_last_7_days',
  'vulnerable_customers_this_month',
  'at_risk_customers_last_week',
  'frustrated_ai_agent_this_month',
  'refund_requests_last_30_days',
  // Review / QA workflow
  'unreviewed_last_week',
  'disputed_scores',
  'low_scoring_not_reviewed',
  'reviewed_by_me_this_month',
  'flagged_pending_feedback',
  'open_disputes_last_30_days',
  // Time based
  'tickets_last_30_days',
  'from_this_week',
  'unreviewed_older_than_14_days',
  'low_scoring_last_quarter',
  'escalations_yesterday',
  'created_last_7_days_no_review',
].map((suffix) => `${KEY_PREFIX}${suffix}`)

/**
 * Pick `count` random suggestion keys, excluding any in `exclude` so a refresh
 * always surfaces a fresh set. Falls back to the full pool if excluding would
 * leave fewer than `count` candidates.
 */
export const pickRandomSuggestions = (count = 3, exclude: string[] = []): string[] => {
  const candidates = SUGGESTION_KEYS.filter((key) => !exclude.includes(key))
  const pool = candidates.length >= count ? candidates : [...SUGGESTION_KEYS]

  const shuffled = [...pool]
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }

  return shuffled.slice(0, count)
}
